"use client";
import styled from "styled-components";

export const AllTradesTitle = styled.div`
  & > * {
    text-align: left;
  }
  @media (min-width: 1024px) {
    padding: 0 16px;
  }
`;

export const AssetsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  .pool > div {
    min-width: 0;
    min-height: 200px;
    button {
      padding: 0 4px;
    }
  }
  @media (min-width: 768px) {
    gap: 24px;
    .pool > div {
      min-height: 0;
    }
  }
  @media (min-width: 1024px) {
    .awaiting__buttons {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }
  }
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
